import React, { useEffect, useState } from "react";
import { exportDeals } from "../../api/dealreport";
import { toast } from "react-toastify";
import { fetchAllDealSourcesActive } from "../../api/dealsource";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";

interface OptionType {
  label: string;
  value: string;
  isDisabled?: boolean;
}

const DealReportModal = () => {
  const fieldOptions: OptionType[] = [
    { value: "ALL", label: "All Fields" },
    { value: "lead_owner_name", label: "Lead Owner" },
    { value: "deal_source_name", label: "Deal Source" },
    { value: "deal_status", label: "Deal Status" },
    { value: "deal_description", label: "Description" },
    // { value: "follow_up_date", label: "Follow Up Date" },
    // { value: "expected_closing_date", label: "Expected Closing Date" },
    // { value: "due_date", label: "Due Date" },
    // { value: "currency", label: "Currency" },
    { value: "deal_value", label: "Deal Value" },
  ];

  const filterTypeOptions: OptionType[] = [
    { value: "", label: "Choose Filter Type", isDisabled: true },
    { value: "dealsource", label: "Deal Source" },
  ];

  const monthOptions: OptionType[] = [
    { value: "", label: "Choose Month", isDisabled: true },
    ...Array.from({ length: 12 }, (_, i) => ({
      value: `${i + 1}`,
      label: new Date(0, i).toLocaleString("default", { month: "long" }),
    })),
  ];

  const dealStatusOptions: OptionType[] = [
    { value: "", label: "Choose Status", isDisabled: true },
    { value: "won", label: "Won" },
    { value: "lost", label: "Lost" },
    { value: "open", label: "Open" },
    { value: "Closed", label: "Closed" },
  ];

  const [field, setField] = useState<OptionType[]>([]);
  const [exportType, setExportType] = useState<OptionType | null>(null);
  const [filterType, setFilterType] = useState<OptionType | null>(null);
  const [filterId, setFilterId] = useState<OptionType | null>(null);
  const [filterIdOptions, setFilterIdOptions] = useState<OptionType[]>([]);
  const [year, setYear] = useState<string>("");
  const [month, setMonth] = useState<OptionType | null>(null);
  const [dealStatus, setDealStatus] = useState<OptionType | null>(null);

  const exportTypeOptions: OptionType[] = [
    { value: "", label: "Choose Export Type", isDisabled: true },
    { value: "pdf", label: "Download as PDF", isDisabled: field.length > 10 },
    { value: "excel", label: "Download as Excel" },
  ];
  useEffect(() => {
    const loadFilterOptions = async () => {
      if (!filterType) return;
      let data: any[] = [];
      switch (filterType.value) {
        case "dealsource":
          data = await fetchAllDealSourcesActive();
          setFilterIdOptions(
            data.map((i) => ({
              label: i.deal_source_nema,
              value: i.deal_source_id || "",
            }))
          );
          break;
        default:
          setFilterIdOptions([]);
      }
    };
    loadFilterOptions();
  }, [filterType]);

  const resetForm = () => {
    setField([]);
    setExportType(null);
    setFilterType(null);
    setFilterId(null);
    setFilterIdOptions([]);
    setYear("");
    setMonth(null);
    setDealStatus(null);
  };

  const handleDownload = () => {
    if (!field.length || !exportType || !year) {
      toast.warning(
        "Please fill all required fields: Fields, Export Type, and Year."
      );
      return;
    }
    const isPdfTooWide = exportType?.value === "pdf" && field.length > 10;

    if (isPdfTooWide) {
      toast.warning(
        "PDF export supports up to 10 fields. Please reduce the selection or use Excel."
      );
      return;
    }

    exportDeals({
      fields: field.find((f) => f.value === "ALL")
        ? fieldOptions
            .filter((f) => f.value !== "ALL")
            .map((f) => f.value)
            .join(",")
        : field.map((f) => f.value).join(","),
      export_type: exportType.value as "pdf" | "excel",
      filter_type: filterType?.value || "",
      filter_id: filterId?.value ?? "",
      year: +year,
      month: month?.value ? +month.value : undefined,
      deal_status: dealStatus?.value,
    });

    resetForm();
  };

  return (
    <>
      <div
        className="modal custom-modal fade effect-modal-show"
        id="download_deal_report"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header border-bottom">
  <div>
    <h4 className="modal-title text-primary fw-semibold d-flex align-items-center gap-2">
      <i className="ti ti-file-download text-primary" />
      Export Deal Report
    </h4>
    <small className="text-muted">
      Customize fields, filters, and export format
    </small>
  </div>

  <button
    type="button"
    className="btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
</div>


            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Fields<span className="text-danger">*</span>
                  </label>
                  <Select
                    isMulti
                    classNamePrefix="react-select"
                    className="select"
                    options={fieldOptions.filter(
                      (opt) => !field.find((f) => f.value === opt.value)
                    )}
                   placeholder={
  field.length === 0
    ? "Choose fields to include in report"
    : `${field.length} fields selected`
}

                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    value={field}
                    onChange={(selectedOptions) => {
                      const selected = selectedOptions as OptionType[];
                      if (selected.some((opt) => opt.value === "ALL")) {
                        setField(fieldOptions.filter((f) => f.value !== "ALL")); // Select all except "ALL"
                      } else {
                        setField(selected);
                      }
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "auto",
                        height: "auto",
                        boxShadow: state.isFocused
                          ? "0 0 0 1px #ccc"
                          : base.boxShadow,
                        borderColor: state.isFocused
                          ? "#ccc"
                          : base.borderColor,
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        flexWrap: "wrap",
                        maxHeight: "100%",
                        overflowY: "auto",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                      }),
                      indicatorsContainer: (base) => ({
                        ...base,
                        flexShrink: 0,
                      }),
                      multiValue: (base) => ({
                        ...base,
                         backgroundColor: "#eef2ff",
                        borderRadius: "8px",
                        padding: "2px 6px",
                        fontSize: "0.85rem",
                      }),
                      multiValueLabel: (base) => ({
                        ...base,
                         color: "#1e40af",
                        fontWeight: 500,
                      }),
                      multiValueRemove: (base) => ({
                        ...base,
                        color: "#888",
                        ":hover": {
                          backgroundColor: "#ccc",
                          color: "#000",
                        },
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                  {field.length > 0 && (
                    <div className="mt-2">
                      <span
                        className={`badge ${
                          field.length > 10 ? "bg-danger" : "bg-secondary"
                        }`}
                      >
                        {field.length} field{field.length > 1 ? "s" : ""}{" "}
                        selected
                        {field.length > 10 && " — PDF allows max 10"}
                      </span>
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    Export Type<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    className="select"
                    options={exportTypeOptions}
                    placeholder="Select Type"
                    onChange={(e) => setExportType(e)}
                    value={exportType}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Filter Type</label>
                  <Select
                    classNamePrefix="react-select"
                    className="select"
                    options={filterTypeOptions}
                    onChange={(e) => {
                      setFilterType(e);
                      setFilterId(null); // ✅ Reset filterId when filterType changes
                    }}
                    value={filterType} // ✅ Add this line
                    
  placeholder={
    filterType ? "Select filter value" : "Choose filter type first"
  }
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    {filterType?.label || "Filter"}
                  </label>
                  <Select
  classNamePrefix="react-select"
  className="select"
  options={filterIdOptions}
  value={filterId}
  onChange={(e) => setFilterId(e)}
  isDisabled={!filterType}
  placeholder={
    filterType ? "Select filter value" : "Choose filter type first"
  }
/>

                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">
                       Year<span className="text-danger">*</span>
                    </label>
                   <input
  type="text"
  inputMode="numeric"
  maxLength={4}
  className="form-control"
  placeholder="YYYY"
  value={year}
  onChange={(e) => {
    if (/^\d{0,4}$/.test(e.target.value)) {
      setYear(e.target.value);
    }
  }}
/>

                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">
                      Select Month
                    </label>
                    <Select
                      classNamePrefix="react-select"
                      className="select"
                      options={monthOptions}
                      value={month}
                      placeholder="Select Month"
                      onChange={(e) => setMonth(e)}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Deal Status</label>
                  <Select
                    classNamePrefix="react-select"
                    className="select"
                    options={dealStatusOptions}
                    placeholder="Select Deal Status"
                    onChange={(e) => setDealStatus(e)}
                    value={dealStatus}
                  />
                </div>

               <div className="d-flex justify-content-between align-items-center mt-4">
  <small className="text-muted">
    {field.length === 0
      ? "Select at least one field to enable export"
      : "Ready to export deal report"}
  </small>

  <div className="d-flex gap-2">
    <button
      type="button"
      className="btn btn-light"
      data-bs-dismiss="modal"
      onClick={resetForm}
    >
      Cancel
    </button>

    <button
      type="button"
      className="btn btn-primary"
      onClick={handleDownload}
      data-bs-dismiss="modal"
      disabled={field.length === 0}
    >
      <i className="ti ti-download me-1" />
      Export
    </button>
  </div>
</div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DealReportModal;
